import { useMemo } from 'react';
import type { VariantOf } from 'variant';
import type { SelectGroup, SelectOption } from '@wix/cli-ui-kit';
import { match, variant } from 'variant';

const DevCenterGenerateFlow = variant({
  DashboardPage: {},
  DashboardPlugin: {},
  DashboardMenuPlugin: {},
  DashboardModal: {},
  DashboardExternalPage: {},
  Event: {},
  DataCollection: {},
  ServicePlugin: {},
  EmbeddedScript: {},
  SitePlugin: {},
  CustomElement: {},
  EditorReactComponent: {},
  AppTools: {},
});

export type GenerateFlow = VariantOf<typeof DevCenterGenerateFlow>;

export const getGenerateFlowByKey = (
  key: keyof typeof DevCenterGenerateFlow
): SelectOption<GenerateFlow> => {
  return match(key, {
    DashboardPage: () => ({
      key,
      title: 'Dashboard Page',
      value: DevCenterGenerateFlow.DashboardPage(),
    }),
    DashboardModal: () => ({
      key,
      title: 'Dashboard Modal',
      value: DevCenterGenerateFlow.DashboardModal(),
    }),
    DashboardPlugin: () => ({
      key,
      title: 'Dashboard Plugin',
      value: DevCenterGenerateFlow.DashboardPlugin(),
    }),
    DashboardMenuPlugin: () => ({
      key,
      title: 'Dashboard menu plugin',
      value: DevCenterGenerateFlow.DashboardMenuPlugin(),
    }),
    DashboardExternalPage: () => ({
      key,
      title: 'Dashboard External Page',
      value: DevCenterGenerateFlow.DashboardExternalPage(),
    }),
    EmbeddedScript: () => ({
      key,
      title: 'Embedded Script',
      value: DevCenterGenerateFlow.EmbeddedScript(),
    }),
    SitePlugin: () => ({
      key,
      title: 'Site Plugin',
      value: DevCenterGenerateFlow.SitePlugin(),
    }),
    Event: () => ({
      key,
      title: 'Event',
      value: DevCenterGenerateFlow.Event(),
    }),
    ServicePlugin: () => ({
      key,
      title: 'Service Plugin',
      value: DevCenterGenerateFlow.ServicePlugin(),
    }),
    DataCollection: () => ({
      key,
      title: 'Data Collection',
      value: DevCenterGenerateFlow.DataCollection(),
    }),
    CustomElement: () => ({
      key,
      title: 'Custom Element',
      value: DevCenterGenerateFlow.CustomElement(),
    }),
    EditorReactComponent: () => ({
      key,
      title: 'Editor React Component',
      value: DevCenterGenerateFlow.EditorReactComponent(),
    }),
    AppTools: () => ({
      key,
      title: 'App Tools',
      value: DevCenterGenerateFlow.AppTools(),
    }),
  });
};

export const useGenerateFlows = (): Array<SelectGroup<GenerateFlow>> => {
  return useMemo(() => {
    return [
      {
        title: 'Dashboard',
        items: [
          getGenerateFlowByKey('DashboardPage'),
          getGenerateFlowByKey('DashboardModal'),
          getGenerateFlowByKey('DashboardPlugin'),
          getGenerateFlowByKey('DashboardMenuPlugin'),
          getGenerateFlowByKey('DashboardExternalPage'),
        ],
      },
      {
        title: 'Site',
        items: [
          getGenerateFlowByKey('EmbeddedScript'),
          getGenerateFlowByKey('SitePlugin'),
          getGenerateFlowByKey('CustomElement'),
          getGenerateFlowByKey('EditorReactComponent'),
        ],
      },
      {
        title: 'Backend',
        items: [
          getGenerateFlowByKey('Event'),
          getGenerateFlowByKey('ServicePlugin'),
          getGenerateFlowByKey('DataCollection'),
          getGenerateFlowByKey('AppTools'),
        ],
      },
    ];
  }, []);
};
